/* eslint-disable no-extend-native */
if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function(searchValue, replaceValue) {
        
        if (this == null) {
            throw new TypeError('String.prototype.replaceAll called on null or undefined');
        }

        if (searchValue instanceof RegExp) {
            if (!searchValue.global) {
                throw new TypeError('replaceAll must be called with a global RegExp');
            }
            return String.prototype.replace.call(this, searchValue, replaceValue);
        }

        const searchString = String(searchValue);

        const escapedSearchString = searchString.replace(/[.*+?^${}()|[\]\\\\]/g, '\\\\$&');

        const globalRegExp = new RegExp(escapedSearchString, 'g');

        return String.prototype.replace.call(this, globalRegExp, replaceValue);
    };
}

export {}